<template>
    <div id="main">
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />
        <div class="listing-header mb-3">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t('insert-produto-agregado') }}
                </h1>
            </div>
            <div class="header-buttons">
                <button class="delete-btn" type="button" @click="onFecharModal">
                    {{ $t('cancelar') }}
                </button>
                <button class="save-btn" type="button" @click="save">
                    {{ $t('salvar') }}
                </button>
            </div>
        </div>

        <div class="tabela" v-if="!isEdit">
            <div class="search-and-filter">
                <div class="search-bar">
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-campo-busca-produto"
                    />
                </div>
            </div>

            <div class="registry-wrapper">
                <container-loader v-if="isLoading && !$store.getters.isLoading" />
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="produtosAgregados"
                    class="data-table"
                    checkable
                    :checked-rows.sync="produtosAgregadosSelecionados"
                    :custom-is-checked="
                        (selecionados, produto) => selecionados.idproduto === produto.idproduto
                    "
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="$t(f.key)"
                        :width="f.width"
                        :sortable="f.sortable"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'descricao'">
                            <a @click="select(props.row)">
                                {{ props.row[f.key] }}
                            </a>
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>

                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>
        </div>
    </div>
</template>

<script>
import VenProdutoService from '@/services/vendas/produto/VenProdutoService';
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    components: {
        ContainerLoader,
    },
    props: {
        isUpdate: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            service: new VenProdutoService(this.$http, this.$router),
            isLoading: false,
            msgs: [],
            produtosAgregados: [],
            produtosAgregadosSelecionados: [],
            isEmpty: false,
            fields: [
                { key: 'descricao', label: 'produto', sortable: true },
                { key: 'grupoproduto', label: 'grupoproduto', sortable: true },
                { key: 'subgrupoproduto', label: 'subgrupoproduto', sortable: true },
            ],
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'produto',
            order: 'asc',
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            msgs: [],
            isEdit: false,
            idproduto: 0,
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.idproduto = this.$route.params.id;

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);

        this.carregarDados();
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1) {
                this.pagination.resetPagination = true;
            }

            this.isLoading = true;

            this.service
                .loadAllAgregadosDisponiveis(
                    this.idproduto,
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.produtosAgregados = value;
                    this.isEmpty = this.produtosAgregados.length === 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os dados.');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    idprodutoagregado: m.ididprodutoagregado,
                    codigo: m.idprodutoerp,
                    descricao: m.descricao,
                    idprodutoprincipal: m.idprodutoprincipal,
                    idproduto: m.idproduto,
                    datahorainc: m.datahorainc,
                    grupoproduto: m.grupoproduto.descricao,
                    subgrupoproduto: m.subgrupoproduto.descricao,
                };
            });
        },
        generateId(numberId) {
            return this.$route.name + '-agregado-' + numberId;
        },
        save() {
            this.isLoading = true;

            if (this.produtosAgregadosSelecionados.length > 0) {
                this.produtosAgregadosSelecionados.forEach((um) => {
                    um.idprodutoprincipal = this.idproduto;
                });

                this.service
                    .addListAgregados(this.produtosAgregadosSelecionados)
                    .then((value) => {
                        if (value.content === null) {
                            this.$root.showMessage('error', `${value.message}`);
                        } else {
                            this.$root.showMessage(
                                'success',
                                'msg-sucesso-ao-adicionar-produto-agregado'
                            );
                            setTimeout(() => {
                                this.$emit('fecharModal', true);
                            }, 200);
                        }
                    })
                    .catch((e) => {
                        this.$root.showMessage('alert', 'msg-erro-load');
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });

                this.isLoading = false;
            } else {
                this.$root.showMessage('error', 'msg-selecione-produto');
                this.isLoading = false;
            }
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        select(selected) {
            this.$emit('selected', selected);
        },
        onFecharModal() {
            this.$emit('fecharModal', true);
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 20px 20px;

    .search-and-filter {
        .search-bar {
            width: 100%;
        }
        @media (max-width: 760px) {
            .search-bar {
                padding-right: 0;
            }
        }
    }
}
</style>
